import WRAP from "WRAP-JS";
// import LegendAirway from "../legend/LegendAirway";
import {
  configAirwayDh,
  configAirwayLayer,
  configAirwayLabelLayer
} from "./config/ConfigAirway";
import { MAP_ID_AIRWAY } from "../../../store/MapContentsState";
import { getCycleDate } from "../../../Authorization";
import { COMMUNICATE_ERROR_MESSAGE_AIRWAY, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";

export const AIRWAY_LEVEL_BOTH = 'BOTH';
export const AIRWAY_LEVEL_HIGH = 'HIGH';
export const AIRWAY_LEVEL_LOW  = 'LOW';

class Airway {
  static NAME = MAP_ID_AIRWAY
  static AIRWAY_INTERNATIONAL_NAME = Airway.makeContentsKey("ITN");
  static AIRWAY_DOMESTIC_NAME = Airway.makeContentsKey("DOM");
  static AIRWAY_OTHER_NAME = Airway.makeContentsKey("OTH");
  static AIRWAY_LABEL = Airway.makeContentsKey("LABEL");
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [Airway.AIRWAY_INTERNATIONAL_NAME]: true,
    [Airway.AIRWAY_DOMESTIC_NAME]: true,
    [Airway.AIRWAY_OTHER_NAME]: true,
  };

  contentsVisibleState = {...Airway.CONTENTS_VISIBLE_STATE_DEFAULT};

  tileIndex;
  dhAirway;
  layerAirway;
  layerAirwayLabel;
  labelVisibleState = true;
  level;
  ready = false;
  contentsDispatcher;
  errorMessageInfo;

  constructor() {
    this.layerAirway = new WRAP.Geo.Layer(Airway.AIRWAY_INTERNATIONAL_NAME);
    this.layerAirway.setVisible(false);
    this.layerAirwayLabel = new WRAP.Geo.Layer(Airway.AIRWAY_LABEL);
    this.layerAirwayLabel.setVisible(false);
    this.layerAirwayLabel.disableInteraction(true);
    this.level = AIRWAY_LEVEL_BOTH;
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {
    this.dhAirway = new WRAP.Data(configAirwayDh);
    return new Promise((resolve) => {
      this.dhAirway.updated('index', ref => {
        if (this.errorMessageInfo) {
          this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo});
          this.errorMessageInfo = null;
        }
        if (ref && Array.isArray(ref)) {
          const cycleDate = getCycleDate();
          const target = ref.find(data => data.Cycledate === cycleDate);
          this.tileIndex = target?.Prefix;
        }
        if (this.tileIndex) {
          resolve();
        }
      }, () => {
        this.errorMessageInfo = this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_AIRWAY,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
      });
    });
  }

  initLayer() {
    this.layerAirway.configure(this.dhAirway, configAirwayLayer);
    this.layerAirwayLabel.configure(this.dhAirway, configAirwayLabelLayer);
    this.layerAirway.set({
      index: this.tileIndex
    });
    this.layerAirwayLabel.set({
      index: this.tileIndex
    });

    const displayToolTip = (geo) => {
      return geo.properties.name;
    };

    this.layerAirway.setTooltip(displayToolTip);

    const attributes = {
      filter: this._visibleFilter.bind(this),
      level: () => this.level
    }
    this.layerAirway.setAttributes(attributes);
    this.layerAirwayLabel.setAttributes(attributes);
  }

  async drawLayer(visible) {
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(visible);
  }
  getLayer() {
    return [this.layerAirway, this.layerAirwayLabel];
  }

  setVisible(visible, contents) {
    this.visible = visible;
    if (contents) {
      this.contentsVisibleState[contents] = visible;
    }
    if (!this.ready) return;

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      this.layerAirway.invalidate();
      this.layerAirwayLabel.invalidate();
    } else {
      if(visible) {
        this.layerAirway.show();
      } else {
        this.layerAirway.hide();
      }
      if(visible && this.labelVisibleState) {
        this.layerAirwayLabel.show();
      } else {
        this.layerAirwayLabel.hide();
      }
    }
  }

  getLegend() {
    return {
      id: Airway.NAME,
      label: 'AIRWAY'
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...Airway.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  getLabelVisibleState() {
    return this.labelVisibleState;
  }

  setLabelVisibleState(visible) {
    this.labelVisibleState = visible;
    if (visible && this.visible) {
      this.layerAirwayLabel.show();
    } else {
      this.layerAirwayLabel.hide();
    }
  }

  getLevel() {
    return this.level;
  }

  setLevel(level) {
    if (level === this.level) return;

    this.level = level;
    this.layerAirway.invalidate();
  }

  changeRoutePointEditing(routePointEditing) {
    this.layerAirway.disableInteraction(routePointEditing);
  }

  _visibleFilter(feature) {
    return this.contentsVisibleState[ Airway.makeContentsKey(feature.properties.kind) ];
  }

  static makeContentsKey(kind) {
    return `${Airway.NAME}_${kind}`;
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default Airway;
